var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPrevButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 25.3585,
    fill: "#4073F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.341 35.3558C51.4623 34.4369 50.0377 34.4369 49.159 35.3558L38.659 46.3362C37.7803 47.2551 37.7803 48.7449 38.659 49.6638L49.159 60.6442C50.0377 61.563 51.4623 61.563 52.341 60.6442C53.2197 59.7253 53.2197 58.2355 52.341 57.3166L43.432 48L52.341 38.6834C53.2197 37.7645 53.2197 36.2747 52.341 35.3558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPrevButton);
export default __webpack_public_path__ + "static/media/top_prev_button.d3ee03b067b00cfd4b7606d3d6ee4700.svg";
export { ForwardRef as ReactComponent };